import { render, staticRenderFns } from "./TouristItem.vue?vue&type=template&id=0689516e&scoped=true"
import script from "./TouristItem.vue?vue&type=script&lang=js"
export * from "./TouristItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0689516e",
  null
  
)

export default component.exports